import React from 'react';
import { observer } from 'mobx-react';
import { SpecialCharacterButtonsWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { pixify } from '@seedlang/utils';
import SoftButton from 'components/button/soft_button';
import { Theme } from '@seedlang/constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  overflow: auto;
  width: ${props => pixify(props.width)};
  padding: ${props => pixify(props.padding)};
  margin: ${props => props.margin};
`;

const Button = styled(SoftButton)`
  color: ${props => props.disabled ? '#868686' : '#333'};
  background: ${props => props.disabled ? '#CCC' : Theme.softButtonBackground};
  height: 30px;
  letter-spacing: normal;
  padding: ${props => props.padding};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  text-transform: none;
  webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
`;

@observer
class SpecialCharacterButtons extends React.Component {

  static defaultProps = {
    padding: '5px 10px',
    lineHeight: '14px',
    fontSize: '16px',
    background: Theme.softButtonBackground,
  };

  render() {
    if ((AppUI.siteIsSeedlang && AppUI.user?.showSpecialCharacters === false) || !this.props.options?.length) {
      return null;
    }

    return (
      <Wrapper
        className={this.props.className}
        style={this.props.style}
        center={this.props.center}
        margin={this.props.margin}
        width={this.props.width}
        padding={this.props.outerPadding}
      >
        {
          this.props.options.map((item, index) => {
            return (
              <Button
                as='div'
                key={item}
                padding={this.props.padding}
                fontSize={this.props.fontSize}
                lineHeight={this.props.lineHeight}
                disabled={this.props.disabled}
                onClick={() => this.props.onClick(item)}
                margin={index === 0 && this.props.center ? '0 5px 0 auto' : index === this.props.options.length - 1 && this.props.center ? '0 auto 0 5px' : undefined}
              >
                {item}
              </Button>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default SpecialCharacterButtonsWrapper(SpecialCharacterButtons);
